export default __webpack_public_path__ + "60c22fd4236393e4115943d2000bbed4.ttf";